(function () {
  const BAR_SELECTOR = '.free-shipping-progress';
  const DEFAULT_EXCLUDED_TAGS = ['substrat fertil', 'palette', 'transport_pietre'];
  let refreshTimer;
  let inFlightRequest;

  function formatLei(cents) {
    const value = Math.max(0, cents) / 100;
    return `${new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)} lei`;
  }

  function normalizeText(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function parseExcludedTags(bar) {
    const raw = bar.dataset.excludedTags || DEFAULT_EXCLUDED_TAGS.join(',');
    return raw
      .split(',')
      .map((tag) => normalizeText(tag))
      .filter(Boolean);
  }

  function isExcludedByTags(productTags, excludedTags) {
    if (!excludedTags.length) return false;
    return excludedTags.some((excludedTag) =>
      productTags.some((productTag) => productTag === excludedTag || productTag.includes(excludedTag))
    );
  }

  function getCartItemsForBar(bar) {
    const localContainer = bar.closest('cart-items') || bar.closest('cart-drawer');
    if (localContainer) {
      const localItems = localContainer.querySelectorAll('.cart-item[data-product-tags]');
      if (localItems.length) return localItems;
    }

    const drawerItems = document.querySelectorAll('cart-drawer .cart-item[data-product-tags]');
    if (drawerItems.length) return drawerItems;

    return document.querySelectorAll('cart-items .cart-item[data-product-tags]');
  }

  function setWarning(bar, message) {
    const warning = bar.querySelector('.free-shipping-progress__warning');
    if (!warning) return;

    if (!message) {
      warning.hidden = true;
      warning.textContent = '';
      bar.classList.remove('has-warning');
      return;
    }

    warning.hidden = false;
    warning.textContent = message;
    bar.classList.add('has-warning');
  }

  function collectCartEligibilityData(bar) {
    const cartItems = getCartItemsForBar(bar);
    if (!cartItems.length) return null;

    const excludedTags = parseExcludedTags(bar);
    const blockedProductNames = [];
    let eligibleTotal = 0;
    let excludedTotal = 0;

    cartItems.forEach((item) => {
      const tags = (item.dataset.productTags || '')
        .split(',')
        .map((tag) => normalizeText(tag))
        .filter(Boolean);
      const isExcluded = isExcludedByTags(tags, excludedTags);
      const lineFinalPrice = Number.parseInt(item.dataset.lineFinalPrice, 10) || 0;
      const nameEl = item.querySelector('.cart-item__name');
      const productName = (item.dataset.productTitle || (nameEl ? nameEl.textContent : '') || '').trim();

      if (isExcluded) {
        excludedTotal += lineFinalPrice;
      } else {
        eligibleTotal += lineFinalPrice;
      }

      if (productName && !blockedProductNames.includes(productName)) {
        if (isExcluded) blockedProductNames.push(productName);
      }
    });

    return { eligibleTotal, excludedTotal, blockedProductNames };
  }

  function buildWarningMessage(blockedProductNames) {
    if (!blockedProductNames.length) return '';
    if (blockedProductNames.length === 1) {
      return `Produsul "${blockedProductNames[0]}" nu este inclus in transportul gratuit.`;
    }
    if (blockedProductNames.length === 2) {
      return `Produsele "${blockedProductNames[0]}" si "${blockedProductNames[1]}" nu sunt incluse in transportul gratuit.`;
    }
    return `Unele produse nu sunt incluse in transportul gratuit: "${blockedProductNames[0]}", "${blockedProductNames[1]}" + ${blockedProductNames.length - 2}.`;
  }

  function render(cartTotalPrice) {
    const bars = document.querySelectorAll(BAR_SELECTOR);
    if (!bars.length) return;

    bars.forEach((bar) => {
      const threshold = Number.parseInt(bar.dataset.threshold, 10) || 45000;
      const fill = bar.querySelector('.free-shipping-progress__fill');
      const text = bar.querySelector('.free-shipping-progress__text');
      const percentLabel = bar.querySelector('.free-shipping-progress__percent');
      const currentAmount = bar.querySelector('.free-shipping-progress__meta-current');
      const targetAmount = bar.querySelector('.free-shipping-progress__meta-target');

      if (!fill || !text || threshold <= 0) return;

      const eligibilityData = collectCartEligibilityData(bar);
      const blockedProductNames = eligibilityData ? eligibilityData.blockedProductNames : [];
      const warningMessage = buildWarningMessage(blockedProductNames);
      setWarning(bar, warningMessage);

      const hasExcludedProducts = blockedProductNames.length > 0;
      const progressBaseTotal = eligibilityData ? eligibilityData.eligibleTotal : cartTotalPrice;
      const remaining = threshold - progressBaseTotal;
      const percent = Math.min(100, Math.max(0, (progressBaseTotal / threshold) * 100));
      const isStrictlyEligibleForFreeShipping = !hasExcludedProducts && remaining <= 0;

      fill.style.width = `${percent}%`;
      if (percentLabel) percentLabel.textContent = `${Math.round(percent)}%`;
      if (currentAmount) currentAmount.textContent = formatLei(progressBaseTotal);
      if (targetAmount) targetAmount.textContent = `Prag ${formatLei(threshold)}`;

      const isInCart = bar.closest('cart-items') || bar.closest('cart-drawer');
      const shouldHideWhenAchieved = bar.dataset.hideWhenAchieved === 'true' || isInCart;

      if (remaining > 0) {
        bar.classList.remove('is-complete');
        bar.classList.remove('free-shipping-progress--achieved');
        text.classList.remove('free-shipping-progress__text--success');
        text.innerHTML = `Adauga produse de <strong>${formatLei(remaining)}</strong> pentru transport gratuit`;
        if (hasExcludedProducts) {
          text.innerHTML += '<br><small>Pragul se calculeaza pentru produsele eligibile.</small>';
        }
      } else {
        if (isStrictlyEligibleForFreeShipping) {
          bar.classList.add('is-complete');
          text.classList.add('free-shipping-progress__text--success');
          text.textContent = 'Ai transport gratuit 🚚';
          if (shouldHideWhenAchieved) {
            bar.classList.add('free-shipping-progress--achieved');
          } else {
            bar.classList.remove('free-shipping-progress--achieved');
          }
        } else {
          // Strict rule: if there is any excluded product in cart,
          // the cart is not treated as free-shipping eligible.
          bar.classList.remove('is-complete');
          bar.classList.remove('free-shipping-progress--achieved');
          text.classList.remove('free-shipping-progress__text--success');
          text.innerHTML =
            'Acest cos contine produse care nu sunt incluse in transportul gratuit.<br><small>Transportul gratuit se aplica doar produselor eligibile din cos.</small>';
        }
      }
    });
  }

  function fetchCartAndRender() {
    if (inFlightRequest) return inFlightRequest;

    inFlightRequest = fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        render(cart.total_price || 0);
      })
      .catch(() => {})
      .finally(() => {
        inFlightRequest = null;
      });

    return inFlightRequest;
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(fetchCartAndRender, 180);
  }

  function refreshFromEvent(payload) {
    if (payload && payload.cartData && typeof payload.cartData.total_price === 'number') {
      render(payload.cartData.total_price);
      return;
    }
    scheduleRefresh();
  }

  document.addEventListener('DOMContentLoaded', fetchCartAndRender);
  document.addEventListener('cart:updated', scheduleRefresh);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromEvent);
  }
})();
